(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    function initializeLenicSort() {
    document.querySelectorAll('.lenic-sort-form:not([data-lenic-sort-ready])').forEach((form) => {
      const select = form.querySelector('select[name="sort_by"]');
      const details = form.querySelector('.lenic-sort');
      if (!select || !details) return;
      form.setAttribute('data-lenic-sort-ready', '');
      const labels = {
        manual: 'おすすめ順', 'most-relevant': '関連度順', 'best-selling': '売れ筋順',
        'title-ascending': '商品名：A → Z', 'title-descending': '商品名：Z → A',
        'price-ascending': '価格の安い順', 'price-descending': '価格の高い順',
        'created-ascending': '登録の古い順', 'created-descending': '新着順'
      };
      const update = () => {
        details.querySelector('[data-lenic-sort-label]').textContent = labels[select.value] || select.selectedOptions[0].textContent.trim();
        details.querySelectorAll('[data-sort-value]').forEach((button) => {
          button.querySelector('span').textContent = labels[button.dataset.sortValue] || button.querySelector('span').textContent;
          button.setAttribute('aria-pressed', String(button.dataset.sortValue === select.value));
        });
      };
      update();
      details.addEventListener('click', (event) => {
        const button = event.target.closest('[data-sort-value]');
        if (!button) return;
        select.value = button.dataset.sortValue;
        update();
        details.open = false;
        details.querySelector('summary').focus();
        select.dispatchEvent(new Event('input', { bubbles: true }));
      });
      select.addEventListener('change', update);
      details.addEventListener('keydown', (event) => {
        const buttons = [...details.querySelectorAll('[data-sort-value]')];
        const index = buttons.indexOf(document.activeElement);
        if (event.key === 'Escape') {
          details.open = false;
          details.querySelector('summary').focus();
        } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          details.open = true;
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : event.key === 'ArrowDown' ? (index + 1) % buttons.length : (index - 1 + buttons.length) % buttons.length;
          buttons[next].focus();
        }
      });
      document.addEventListener('click', (event) => { if (!form.contains(event.target)) details.open = false; });
      form.addEventListener('focusout', () => { requestAnimationFrame(() => { if (!form.contains(document.activeElement)) details.open = false; }); });
    });
  }
  initializeLenicSort();
  document.addEventListener('shopify:section:load', initializeLenicSort);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (() => {
  let viewer;
  let viewerImage;
  let viewport;
  let previousOverflow;
  let returnFocus;

  function createViewer() {
    viewer = document.createElement('dialog');
    viewer.className = 'lenic-detail-zoom';
    viewer.setAttribute('aria-label', '商品画像の拡大表示');
    const header = document.createElement('div');
    header.className = 'lenic-detail-zoom__header';
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'lenic-detail-zoom__close';
    close.textContent = '閉じる ×';
    close.setAttribute('autofocus', '');
    header.append(close);
    viewport = document.createElement('div');
    viewport.className = 'lenic-detail-zoom__viewport';
    viewport.tabIndex = 0;
    viewport.setAttribute('aria-label', '画像をスクロールして見る');
    viewerImage = document.createElement('img');
    viewerImage.className = 'lenic-detail-zoom__image';
    viewport.append(viewerImage);
    viewer.append(header, viewport);
    document.body.append(viewer);
    close.addEventListener('click', () => viewer.close());
    viewer.addEventListener('click', (event) => {
      if (event.target !== viewer) return;
      const rect = viewer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) viewer.close();
    });
    viewer.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
    });
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element
      ? event.target.closest('.lenic-product-details-below a, .arkk-detail-images a')
      : null;
    const image = link && link.querySelector('img');
    if (!image || !/\.(?:jpe?g|png|webp|gif)(?:[?#]|$)/i.test(link.href)) return;
    if (!('showModal' in HTMLDialogElement.prototype)) return;
    event.preventDefault();
    if (!viewer) createViewer();
    viewerImage.src = link.href;
    viewerImage.alt = image.alt || '商品詳細画像';
    returnFocus = link;
    previousOverflow = document.documentElement.style.overflow;
    viewer.showModal();
    document.documentElement.style.overflow = 'hidden';
    viewport.scrollTop = 0;
  });
})();
  } catch(e) { console.error(e); }
})();

})();
